module.exports = __webpack_public_path__ + "img/search-product-state.54768dd4.svg";